import {Component, Inject, Output, EventEmitter} from 'ng-metadata/core';

import {getSuspendWatchersActivatedForBrowser, getVid} from '../appConfig/appConfigForward';
import {SearchFieldsService} from '../search/search.fields.service';
import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';
import {JournalsService} from '../journals/journals.service';
import {SkipToService} from '../search/topbar/skipTo/skipTo.service';
import {SearchService} from "../search/search.service";
import {ConfigurationUtil} from '../nddUtils/configurationUtil.service';
import {DatabasesService} from "../journals/databases.service";
import {IAlertMsg} from '../infra/widgets/alerts/alertMsg.interface';
import {AlertFactory, ALERT_MSG_TYPE} from '../infra/widgets/alerts/alertFactory.service';
import {CollectionDiscoveryService} from "../collectionDiscovery/collectionDiscovery.service";
import {NewspapersService} from '../newspapers/newspapers.service';
import {PagesTitlesService} from '../infra/accessibility/pagesTitles.service';
import {OrgListCategorizeService} from '../journals/orgListCategorize/orgListCategorize.service';
import {isBrowserIE} from '../infra/browserSniffer';
import {LoginService} from '../security/login/login.service';
import { AuthoritySearchService } from '../search/authority/authoritySearch.service';

@Component({
    selector: 'prm-explore-main',
    templateUrl: 'components/primoExplore/primo-explore-main.html'
})

export class PrimoExploreMain {
    private vid = getVid();
    private borInfoAlert: IAlertMsg;
    private digestWhenInViewConfigured: boolean;
    private lastSearchMethod: string = null;

    @Output() private showDialogEvent = new EventEmitter<Object>();
    @Output() private hideDialogEvent = new EventEmitter<Object>();

    constructor(@Inject('$state') private $state: angular.ui.IStateService,
                private loginService: LoginService,
                private searchFieldsService: SearchFieldsService,
                private skipToService: SkipToService,
                private searchService: SearchService,
                private journalsService: JournalsService,
                private databasesService: DatabasesService,
                private orgListService: OrgListCategorizeService,
                private configurationUtil: ConfigurationUtil,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                private alertService: AlertFactory,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
                private collectionDiscoveryService: CollectionDiscoveryService,
                private newspapersService: NewspapersService,
                private pagesTitlesService: PagesTitlesService,
                private authoritySearchService: AuthoritySearchService) {
        this.setLoginErrorMessage();
        this.digestWhenInViewConfigured = (getSuspendWatchersActivatedForBrowser() === "ALL") || (getSuspendWatchersActivatedForBrowser() === "IE" && isBrowserIE());

        $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
            if ([STATE_NAMES.DB_SEARCH, STATE_NAMES.JOURNAL_SEARCH, STATE_NAMES.NEWSPAPERS, STATE_NAMES.SEARCH].indexOf(toState.name) !== -1) {
                this.lastSearchMethod = toState.name;
            }
            else if (([STATE_NAMES.FAVORITES].indexOf(toState.name) !== -1) && fromState.name !== null && fromState.name !== toState.name){
                this.lastSearchMethod = fromState.name;
            }
        });


        let actionToCode = {
            'exploreMain.browseSearch': !this.isSuprima() ? ['nui.mainmenu.label.browse'] : ['mainmenu.label.BrowseSearch'],
            'exploreMain.jsearch': !this.isSuprima() ? ['nui.mainmenu.label.journalsearch'] : ['mainmenu.label.JournalSearch'],
            'tags': ['nui.mainmenu.label.tags', 'main.title'],
            'exploreMain.citationlinker': !this.isSuprima() ? ['nui.mainmenu.label.citationlinker'] : ['mainmenu.label.citationlinker'],
            'exploreMain.dbsearch': !this.isSuprima() ? ['nui.mainmenu.label.databasesearch'] : ['mainmenu.label.DatabaseSearch'],
            'exploreMain.npsearch': !this.isSuprima() ? ['nui.mainmenu.label.newspapers_search'] : ['mainmenu.label.NewspaperSearch'],
            'exploreMain.citationTrails': ['nui.citation_trail.link.header'],
            'exploreMain.authsearch':  ['mainmenu.label.AuthoritySearch'],
            'exploreMain.researchAssistant':  ['mainmenu.label.researchAssistant'],
            'blankIll':  ['nui.mainmenu.description.BlankIll'],
            "login": ['main.title']
        };

        let titles = actionToCode[this.$state.current.name];
        this.pagesTitlesService.updatePagesTitles({codes: titles});
    }

    public isSuprima() {
        return this.configurationUtil.isSuprima();
    }


    private setLoginErrorMessage(){
        this.borInfoAlert = this.alertService.create(ALERT_MSG_TYPE.SIGNIN);
        let responseErrorObj = {
            errorMessage : this.$location.search().errorMessage,
            errorType : this.$location.search().errorType,
            errorValue : this.$location.search().errorValue,
            errorDetail : this.$location.search().errorDetail
        };
        let msgValuesObj = this.loginService.getErrorMessageObj(responseErrorObj,'nui.bor_info_failed')
        this.borInfoAlert.show(msgValuesObj.errorMessage, false, msgValuesObj.errorFields);

    }

    private onSearchBarSearchEvent(eventData) {
        let params = {
            query: eventData.mainSearchField,
            search_scope: eventData.scopeField,
            featured_scope: eventData.featuredScopeField,
            vid: this.vid,
            tab: eventData.tab,
            mode: eventData.mode,
            facet: eventData.facet,
            mfacet: eventData.mfacet,
            pfilter: eventData.pfilter,
            journals: eventData.journals,
            databases: eventData.databases,
            organization: eventData.organization,
            organizationPath: eventData.organizationPath,
            sortby: eventData.sortby,
            offset: 0,
            conVoc: undefined,
            issn: eventData.issn,
            fromDate: eventData.fromDate
        };
        let stateName = this.lastSearchMethod != null ? this.lastSearchMethod : STATE_NAMES.SEARCH;
        if (this.journalsService.isJournalSearch()) {
            stateName = STATE_NAMES.JOURNAL_SEARCH;
        }
        if (this.databasesService.isDBSearch()) {
            stateName = STATE_NAMES.DB_SEARCH;
        }
        if (this.isNewspapersSearch) {
            params.pcAvailability = this.searchService.calcPcAvailability();
            stateName = STATE_NAMES.NEWSPAPERS;
        }
        if (this.orgListService.isOrgListSearch() && params.organization) {
            stateName = STATE_NAMES.ORGANIZATION_LIST;
        }
        this.searchFieldsService.searchParams = params;
        return this.$state.go(stateName, params, {reload: stateName});
    }

    private hasSearchResults(): boolean {
        let res = this.searchService.getResultObject().data;
        return Array.isArray(res) && res.length > 0;
    }

    private get searchInProgress() {
        if (this.$state.is(STATE_NAMES.COLLECTION_DISCOVERY)) {
            return this.collectionDiscoveryService.searchInProgress;
        }
        return this.searchService.isSearchInProgress();
    }

    public showSearchBar() {
        return this.$state.current.name !== STATE_NAMES.CITATION_TRAILS && this.$state.current.name !== STATE_NAMES.CITATION_LINKER && this.$state.current.name !== STATE_NAMES.COLLECTION_DISCOVERY;
    }

    public allowSearch() {

        // For Summon over Alma, we want to block the visibility of the search page
        // User still allowed to access 'Journal Search', 'My Account' and 'Browse Search' pages
        if (this.configurationUtil.isSuprima() &&
            this.$state.current.name === STATE_NAMES.SEARCH &&
            this.configurationUtil.getSummonOverAlma() === true) {
            return (this.$state.params.browseScope !== undefined);
        }

        // For Alma E user ( Discovery Services Page), we want to block the visibility of the search page
        // User still allowed to access 'Journal Search' page
        if (this.configurationUtil.isSuprima() &&
        this.$state.current.name === STATE_NAMES.SEARCH &&
        this.configurationUtil.getDiscoveryServicesPage() === true) {
        return (this.$state.params.browseScope !== undefined);
    }

        return true;
    }

    private showStatName() {

        if (this.$state.current.name === STATE_NAMES.SEARCH && this.hasSearchResults()) {
            return 'nui.aria.page.searchResults';
        }

        if (this.$state.current.name === STATE_NAMES.SEARCH) {
            return 'nui.aria.page.search';
        }

        if (this.$state.current.name === STATE_NAMES.FAVORITES) {
            return 'nui.aria.page.favorites';
        }

        if (this.$state.current.name === STATE_NAMES.CITATION_TRAILS) {
            return 'nui.aria.page.citation';
        }

        if (this.$state.current.name === STATE_NAMES.BROWSE_SEARCH) {
            return 'nui.aria.page.browsePage'
        }

        if (this.$state.current.name === STATE_NAMES.DB_SEARCH) {
            return 'nui.aria.page.dbSearch'
        }

        if (this.$state.current.name === STATE_NAMES.DB_FULL_DISPLAY) {
            return 'nui.aria.page.dbSearchFullDis '
        }

        if (this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH) {
            return 'nui.aria.page.journal '
        }

        if (this.$state.current.name === STATE_NAMES.JOURNAL_FULL_DISPLAY) {
            return 'nui.aria.page.jurnalFullDis'
        }

        if (this.$state.current.name === STATE_NAMES.AUTHORITY_SEARCH) {
            return 'nui.aria.page.authSearch'
        }
        if (this.$state.current.name === STATE_NAMES.RESEARCH_ASSISTANT) {
            return 'nui.aria.primo_research_assistant';
        }
        // return this.$state.current.name;
    }

    private get isJournalsSearch(): boolean {
        return this.journalsService.isJournalSearch() || this.lastSearchMethod == STATE_NAMES.JOURNAL_SEARCH;
    }

    private get isDBSearch(): boolean {
        return this.databasesService.isDBSearch() || this.lastSearchMethod == STATE_NAMES.DB_SEARCH;
    }

    private get isOrgListSearch(): boolean {
        return this.orgListService.isOrgListSearch();
    }

    private get isAtozSearch() {
        return this.isJournalsSearch || this.isDBSearch;
    }

    private get isBrowseMode() {
        return this.$stateParams['mode'] === 'browse';
    }

    private get showBroseSearchBar() {
        if (this.isBrowseMode || this.$state.current.name == "exploreMain.browseSearch") {
            return true;
        }
        return false;
    }

    private get isAuthorityMode() {
        return this.$stateParams['mode'] === 'authority';
    }

    private get showAuthoritySearchBar() {
        if (this.isAuthorityMode || this.$state.current.name == STATE_NAMES.AUTHORITY_SEARCH || this.$state.current.name == STATE_NAMES.AUTHORITY_FULL_DISPLAY) {
            return true;
        }
        return false;
    }

    private get showChaptersAndReviews() {
        if (this.$state.current.name == "exploreMain.chapters") {
            return true;
        }
        return false;
    }

    private get showPerformanceMonitor() {
        return this.$stateParams.show_performance === 'true';
    }

    private get isCollectionDiscoveryFocused() {
        return this.$state.current.name === STATE_NAMES.COLLECTION_DISCOVERY && this.$stateParams['collectionId']; //in collection discovery page but not lobby (focused on collection)
    }

    private displayBorInfoAlert() {
        if (this.$location.search()['authenticationError'] && this.$location.search()['authenticationError'] === '1') {
            return true;
        }
        return false;
    }

    private isCitationLinker() {
        return this.$state.current.name === STATE_NAMES.CITATION_LINKER;
    }

    private isCollectionDiscovery() {
        return this.$state.current.name === STATE_NAMES.COLLECTION_DISCOVERY;
    }

    private isCitationtrails() {
        return this.$state.current.name === STATE_NAMES.CITATION_TRAILS;
    }

    private isFavorites() {
        return this.$state.current.name === STATE_NAMES.FAVORITES;
    }

    private get isNewspapersSearch() {
        return this.newspapersService.isNewspapersSearch() || this.lastSearchMethod == STATE_NAMES.NEWSPAPERS;
    }

    private get cameFromSearch() {
        return this.newspapersService.cameFromSearch;
    }

    private get cameFromFeaturedSearch() {
        return this.newspapersService.cameFromFeaturedSearch;
    }

    private hideDialog() {
        if (this.digestWhenInViewConfigured) {
            this.$scope.$resume();
        }

    }

    private showDialog() {
        if (this.digestWhenInViewConfigured) {
            this.$scope.$suspend();
        }

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/primoExploreMain.directive.ts